export default server => {
    server.get('/v1/streams', (schema, { queryParams: { account_id } }) => {
        return [
            {
                id: 1,
                title: 'indirect wix mentions - english',
                category: 'stream',
                stream_type: 'twitter_search',
                social_type: 10,
                context_id: 1,
                context_type: 1,
                user_id: account_id,
                created_at: 1542721350
            },
            {
                id: 2,
                title: 'indirect wix mentions - hebrew',
                category: 'stream',
                stream_type: 'twitter_search',
                social_type: 10,
                context_id: 2,
                context_type: 1,
                user_id: account_id,
                created_at: 1542721350
            }
        ];
    });
};
